/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.shared = (await import('./pages/shared/SharedContainer')).SharedContainer;
    Components.sharedMobile = (await import('./pages/shared/SharedMobileContainer')).SharedMobileContainer;
    Components.list = (await import('./pages/list/ListContainer')).ListContainer;
    Components.listMobile = (await import('./pages/list/ListMobileContainer')).ListMobileContainer;
    Components.summary = (await import('./pages/summary/SummaryContainer')).SummaryContainer;
    Components.summaryMobile = (await import('./pages/summary/SummaryMobileContainer')).SummaryMobileContainer;
    Components.home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  shared: {
    name: 'SharedContainer',
    componentName: 'SharedContainer',
    chunk: () => import('./pages/shared/SharedContainer'),
    get component() {
      return ssr
        ? serverPages.shared
        : currentRouteName === 'SharedContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SharedContainer })));
    },
    path: '/:context?/list/view/details/shared/:listId',
    channel: 'desktop'
  },
  sharedMobile: {
    name: 'SharedMobileContainer',
    componentName: 'SharedMobileContainer',
    chunk: () => import('./pages/shared/SharedMobileContainer'),
    get component() {
      return ssr
        ? serverPages.sharedMobile
        : currentRouteName === 'SharedMobileContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SharedMobileContainer })));
    },
    path: '/:context?/list/view/details/shared/:listId',
    channel: 'mobile'
  },
  list: {
    name: 'ListContainer',
    componentName: 'ListContainer',
    chunk: () => import('./pages/list/ListContainer'),
    get component() {
      return ssr
        ? serverPages.list
        : currentRouteName === 'ListContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ListContainer })));
    },
    path: '/:context?/list/view/details/:listId',
    channel: 'desktop'
  },
  listMobile: {
    name: 'ListMobileContainer',
    componentName: 'ListMobileContainer',
    chunk: () => import('./pages/list/ListMobileContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.listMobile
        : currentRouteName === 'ListMobileContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.ListMobileContainer })));
    },
    path: '/:context?/list/view/details/:listId',
    channel: 'mobile'
  },
  summary: {
    name: 'SummaryContainer',
    componentName: 'SummaryContainer',
    chunk: () => import('./pages/summary/SummaryContainer'),
    get component() {
      return ssr
        ? serverPages.summary
        : currentRouteName === 'SummaryContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SummaryContainer })));
    },
    path: '/:context?/list/view/summary',
    channel: 'desktop'
  },
  summaryMobile: {
    name: 'SummaryMobileContainer',
    componentName: 'SummaryMobileContainer',
    chunk: () => import('./pages/summary/SummaryMobileContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.summaryMobile
        : currentRouteName === 'SummaryMobileContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.SummaryMobileContainer })));
    },
    path: '/:context?/list/view/summary',
    channel: 'mobile'
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  }

});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();
  return componentModule[route.componentName];
};
